<div class="submit-form-wrapper">
    <button type="button" (click)="openNewTrafficDeviation()">
        {{ 'New deviation' | translate }}
    </button>
</div>

<div class="tabs-and-filter">
    <app-tabs
        [tabs]="componentState?.tabs"
        [selectedTab]="componentState?.selectedTab"
        (changed)="changeTab($event)"
    ></app-tabs>
    <div class="filter-menu" [matMenuTriggerFor]="menu">
        <i class="fa-solid fa-filter"></i>
    </div>
</div>

<mat-menu #menu="matMenu" xPosition="before">
    <div class="clear-filter" (click)="clearFilter()">
        <i
            [matTooltip]="'Clear filter' | translate"
            class="fa-solid fa-filter-circle-xmark"
        ></i>
    </div>
    @for (filterType of FilterType | keyvalue; track filterType) {
        @if ((_filters$ | async)?.get(filterType.value)?.length) {
            <div class="filter-type">{{ filterType.value | translate }}</div>
            @for (
                filter of (_filters$ | async)?.get(filterType.value);
                track filter
            ) {
                <button mat-menu-item>
                    <mat-checkbox
                        [checked]="isFilterSelected(filterType.key, filter)"
                        (change)="setFilter(filterType.key, filter, $event)"
                        (click)="$event.stopPropagation()"
                    >
                        {{ filter | translate }}
                    </mat-checkbox>
                </button>
            }
        }
    }
</mat-menu>

@if (expiredDeviationsLoading) {
    <div class="py-4">
        <places-spinner [small]="true"></places-spinner>
    </div>
} @else if (trafficDeviations$ | async; as trafficDeviations) {
    @if (trafficDeviations.length > 0) {
        @if (columns$ | async; as columns) {
            <app-compact-list
                [items]="trafficDeviations"
                [columns]="columns"
                (itemSelected)="itemSelected($event)"
                (columnsUpdated)="columnsUpdated($event)"
            >
                <ng-template appCustomCompactListColumn="startDate" let-item>
                    <span>{{
                        item.properties.startDate | customDate: 'MM-dd HH:mm'
                    }}</span>
                </ng-template>
                <ng-template appCustomCompactListColumn="endDate" let-item>
                    <span>{{
                        item.properties.endDate | customDate: 'MM-dd HH:mm'
                    }}</span>
                </ng-template>
                <ng-template appCustomCompactListColumn="affected" let-item>
                    @if (!item.properties.stopCentric) {
                        <div class="affectedWrapper">
              @for (affected of item.properties.affected; track (affected.routeName ?? '') + '|' + (affected.tripNumber ?? '') + '|' + $index; let index = $index) {
                                @if (
                                    affected.routeName && !affected.tripNumber
                                ) {
                                    @if (index < 2 || IsWideWindowWidth) {
                                        <span class="routeName">
                                            {{ affected.routeName }}
                                        </span>
                                    }
                                    @if (
                                        affected.routeName &&
                                        index === 2 &&
                                        !IsWideWindowWidth
                                    ) {
                                        <ng-container class="routeName">
                                            ...
                                        </ng-container>
                                    }
                                }
                                @if (
                                    affected.routeName && affected.tripNumber
                                ) {
                                    @if (index < 1 || IsWideWindowWidth) {
                                        <span class="routeName">
                                            {{ affected.routeName }}
                                        </span>
                                    }
                                    @if (affected.tripNumber) {
                                        <span class="tripNumber">
                                            {{ affected.tripNumber }}
                                        </span>
                                    }
                                    @if (
                                        affected.routeName &&
                                        index === 1 &&
                                        !IsWideWindowWidth
                                    ) {
                                        <ng-container class="routeName">
                                            ...
                                        </ng-container>
                                    }
                                }
                            }
                        </div>
                    }
                </ng-template>
                <ng-template appCustomCompactListColumn="status" let-item>
                    @if (item.properties.status === 2) {
                        <span
                            class="status fa fa-envelope"
                            [matTooltip]="'On the way to SL' | translate"
                            matTooltipPosition="right"
                        >
                        </span>
                    }
                    @if (item.properties.status === 3) {
                        <span
                            class="status fa fa-check"
                            [matTooltip]="'Received by SL' | translate"
                            matTooltipPosition="right"
                        >
                        </span>
                    }
                    @if (item.properties.status >= 4) {
                        <span
                            class="status fa-solid fa-xmark"
                            [matTooltip]="'Something went wrong' | translate"
                            matTooltipPosition="right"
                        >
                        </span>
                    }
                </ng-template>
            </app-compact-list>
        }
    } @else {
        <app-feedback-text type="empty">
            <span translate>No Deviations to show</span>
        </app-feedback-text>
    }
} @else {
    <div class="py-4">
        <places-spinner [small]="true"></places-spinner>
    </div>
}
